// import { date } from "yup";
import http from "../httpService";

//const apiEndpoint = "General/CustomerType";



export async function getCustomerType(id) {
  return http.get("/General/CustomerType?BranchID=" + id);
}
export async function getProductType(id) {
  return http.get("/General/ProductType?BranchID=" + id);
}

export async function getProduct(productype, id) {
  return http.get("/General/Product?Type_id=" + productype + "&BranchID=" + id);
}
export async function getTruckType(id) {
  return http.get("/General/TruckType?BranchID=" + id);
}
export async function getStore(id) {
  return http.get("/General/Store?BranchID=" + id);
}
export async function getCustomer(id) {
  return http.get("/general/CustomerID?BranchID=" + id);
}
export async function GetMasterSourceProduct(id) {
  return http.get("/general/GetMasterSourceProduct?BranchID=" + id);
}
export async function getProvince(id) {
  return http.get("/general/Province?BranchID=" + id);
}
export async function getTailDriven(id) {
  return http.get("/general/getTailDriven?BranchID=" + id);
}
export async function getQueuetime(date, id,productid ,customerid=0,cid="1",Typeid,firstdriven ="",firstdrivenprov ="",Id=0) {
// console.log(date, id,productid ,customerid,cid,Typeid,firstdriven,firstdrivenprov)
  if ( parseInt(Typeid) === 10 &&  parseInt(id) ===510){
    return http.get("/Queue/Queue_Time?Date=" + date + "&BranchID=" + id +"&ProductID="+ productid + "&C_ID="+ 10 + 
    "&customerid="+ customerid + "&FirstDrivenNo=" + firstdriven + "&FirstDrivenProv="+ firstdrivenprov)+"&id="+Id;
     }else{
      return http.get("/Queue/Queue_Time?Date=" + date + "&BranchID=" + id +"&ProductID="+ productid + "&C_ID="+ cid + 
      "&customerid="+ customerid + "&FirstDrivenNo=" + firstdriven + "&FirstDrivenProv="+ firstdrivenprov+"&id="+Id);
     }
  // return http.get("/Queue/Queue_Time?Date=" + date + "&BranchID=" + id +"&ProductID="+ productid+"&customerid="+customerid);
}
export async function getBranchList() {
  return http.get("/JAWIS/getBranch ");
}
export async function getaim(id) {
return http.get("/General/Inorder?branchid=" + id);
}
export async function getowner(id) {
  return http.get("/General/getOwner?branchid=" + id);
  }
export async function gettimeAll(date,id,productid='',cid=10,productTypeId='') {
  if (productTypeId == "10" && id =="501"){
    return http.get("/getWeight/Queue_TT?Date=" + date + "&C_ID="+ cid);
  }else{
    return http.get("/Queue/Queue_Time?Date=" + date + "&BranchID=" + id +"&ProductID="+ productid);

  }

}
export async function getdestination(id) {
  return http.get("/General/getDescName?BranchID=" + id);
}
export async function getRegisterlist(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",search="",pageSize =1000,pageNumber = 1
) {
  // console.log('cusid=',pageNumber);
  return http.get(
    "/JAWIS/RegisterList?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&cusid=" +
      cusid +"&pageSize="+ pageSize +"&pageNumber="+ pageNumber +"&search="+ search
  );
}

export async function GetdataQueueCall(  
  startdate = "",
  enddate = "",
  branchid= "",
  statusid = 0,
  pageSize="",
  pageNumber="",
  search=""
 ) {
  
      return http.get(
     "/wms/getBooking?startdate=" + 
      startdate +
      "&enddate=" +
      enddate +
      "&branchid=" +
      branchid +
      "&statusid=" +
      statusid +
      "&pageSize="+ 
      pageSize +
      "&pageNumber="+ 
      pageNumber +
      "&search="+
      search
      //console.log("asdad",GetdataQueueCall)
     );
  }




export async function getregister(webid, id) {
  // console.log(webid);
  return http.get("/Queue/WebRegisterEdit?branchid=" + id + "&webid=" + webid);
}

export async function getSumaryRegister(start = "", end = "", id) {
  // console.log(start,id,end);
  return http.get(
    "/JAWIS/getSumaryRegister?id=" +
      id +
      "&StartDate=" +
      start +
      "&EndDate=" +
      end
  );
}
export async function getWeightlist(
  start = "",
  end = "",
  branchid = "",
  typeid = "0",search="",pageSize =1000,pageNumber = 1
) {
 // console.log('cusid=',search);
  return http.get(
    "/JAWIS/Weightlist?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      typeid +"&pageSize="+ pageSize +"&pageNumber="+ pageNumber +"&search="+ search
  );
}
export async function getdowood(
  BranchID = "",
  DO = "",
  customertypeid = ""
) {
 // console.log('cusid=',search);
  return http.get(
    "https://wms.advanceagro.net/ws2/api/general/ConfirmDO?BranchID="+ BranchID +"&DO="+ DO +"&customertypeid="+ customertypeid
  );
}
export async function getdowoodcontrolwood(
  BranchID = "",
  DO = "",
  
) {
 // console.log('cusid=',search);
  return http.get(
    "https://wms.advanceagro.net/WS2/api/General/ConfirmDO2?BranchID="+ BranchID +"&DO="+ DO 
  );
}
export function savebooking(doc) {
 
    return http.post("/wms/UpdateStatus", doc);
}
export function chkcovicid(doc) {
 
  return http.post("/vms/CheckCovid", doc);
}
export function savecovic(doc) {
  return http.post("/vms/CovidQuestionnaire", doc);
}

// const exportedObject = {
//   getCustomerType,
//   getProductType,
//   getTruckType,
//   getProduct,
//   getStore,
//   getCustomer,
//   getQueuetime,
//   getBranchList,
//   getaim,
//   getRegisterlist,
//   getregister,
//   getSumaryRegister,
//   gettimeAll,GetdataQueueCall,
//   savebooking,getdowood,chkcovicid,savecovic,getdowoodcontrolwood,
// };

export default {
  getCustomerType,
  getProductType,
  getTruckType,
  getProduct,
  getStore,
  getCustomer,
  getQueuetime,
  getBranchList,
  getaim,
  getRegisterlist,
  getregister,
  getSumaryRegister,
  gettimeAll,GetdataQueueCall,
  savebooking,getdowood,chkcovicid,savecovic,getdowoodcontrolwood,
};
